import React from 'react'
import PropTypes from 'prop-types'
import RoutingBlock from './RoutingBlock'
import TenantFeeBlock from './TenantFeeBlock'
import InitializationFee from "./InitializationFee"
import VirtualNumberManagement from "./VirtualNumberManagement"

BlockCenter.propTypes = {
    custId: PropTypes.string
}

function BlockCenter(props) {
    const {custId} = props;

    return (
        <>
            <VirtualNumberManagement custId={custId}/>
            <RoutingBlock {...props}/>
            <TenantFeeBlock {...props}/>
            <InitializationFee custId={custId}/>
        </>
    )
}

export default BlockCenter
